import React from "react";

// Page look for the PDF (Auto Report Mail and report WhatsApp): white A4,
// header row repeats on every page, rows never split across pages.
export const REPORT_PRINT_CSS = `
  html, body { background: #fff !important; margin: 0; }
  * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .rp-page { font-family: Arial, sans-serif; color: #222; padding: 0 4px; }
  .rp-head { text-align: center; border-bottom: 2px solid #f4a261; padding-bottom: 8px; margin-bottom: 12px; }
  .rp-company { font-size: 18px; font-weight: bold; }
  .rp-title { font-size: 14px; font-weight: bold; margin-top: 4px; }
  .rp-sub { font-size: 12px; color: #555; margin-top: 2px; }
  .rp-table { width: 100%; border-collapse: collapse; font-size: 11px; margin-bottom: 10px; }
  .rp-table thead { display: table-header-group; }
  .rp-table tr { page-break-inside: avoid; break-inside: avoid; }
  .rp-table th { background: #f4a261; border: 1px solid #c9c9c9; padding: 5px 6px; text-align: left; white-space: nowrap; }
  .rp-table td { border: 1px solid #dcdcdc; padding: 4px 6px; vertical-align: top; }
  .rp-table tbody tr:nth-child(even) td { background: #f6f9fc; }
  .rp-table .rp-total td { background: #ffe9a8 !important; font-weight: bold; }
  .rp-num { text-align: right !important; white-space: nowrap; }
  .rp-nowrap { white-space: nowrap; }
  .rp-section { background: #8d99ae; color: #fff; padding: 5px 8px; font-size: 13px; margin: 12px 0 6px; }
  .rp-party { background: #d8f3dc; padding: 4px 8px; font-weight: bold; font-size: 12px; }
  .rp-info { font-size: 12px; margin-bottom: 2px; }
`;

export function ReportHeader({ company, title, sub }) {
  return (
    <div className="rp-head">
      {company ? <div className="rp-company">{company}</div> : null}
      <div className="rp-title">{title}</div>
      {sub ? <div className="rp-sub">{sub}</div> : null}
    </div>
  );
}
